import { render, staticRenderFns } from "./ProductTileSeed.vue?vue&type=template&id=35d3b39c&lang=html&"
import script from "./ProductTileSeed.vue?vue&type=script&lang=js&"
export * from "./ProductTileSeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports